export const MAIN_CATEGORY_ROOT_ID = 454
export const SALE_CATEGORY_ROOT_ID = 536

export const PRODUCT_ARTICLE_TYPE_VALUE_PREMIUM_CLUB = 'pc'

export const GIFT_CARD_ORDER_NUMBERS = ['GUTSCHEINC01', 'GUTSCHEIN01']
